export interface FashionProduct {
  id: string;
  name: string;
  category: 'lancamentos' | 'vestuario' | 'calcados' | 'acessorios';
  price: number;
  originalPrice?: number;
  sizes: string[];
  colors: string[];
  description: string;
  images: string[];
  badge?: string;
  isPopular?: boolean;
}

export interface FashionOrder {
  id: string;
  customerName: string;
  items: string[];
  total: number;
  status: 'Aguardando Envio' | 'Enviado' | 'Entregue';
  trackingCode: string;
  date: string;
}

export const fashionProducts: FashionProduct[] = [
  {
    id: 'prod_001',
    name: 'Scarpin Luiza Barcelos Couro Nude',
    category: 'calcados',
    price: 649.90,
    originalPrice: 789.90,
    sizes: ['34', '35', '36', '37', '38'],
    colors: ['Nude Mantiqueira', 'Preto Carvão'],
    description: 'Scarpin em couro legítimo com salto fino 8cm e palmilha conforto acolchoada.',
    images: ['https://images.unsplash.com/photo-1543163521-1bf539c55dd2?auto=format&fit=crop&w=600&q=80'],
    badge: '🔥 Bestseller',
    isPopular: true
  },
  {
    id: 'prod_002',
    name: 'Blazer Alfaiataria Oversized Lã Fria',
    category: 'vestuario',
    price: 899.00,
    sizes: ['P', 'M', 'G'],
    colors: ['Off-White', 'Preto', 'Camel'],
    description: 'Blazer de corte reto estruturado com ombreiras suaves e forro em cetim de seda.',
    images: ['https://images.unsplash.com/photo-1591047139829-d91aecb6caea?auto=format&fit=crop&w=600&q=80'],
    badge: '⭐ Edição Limitada',
    isPopular: true
  },
  {
    id: 'prod_003',
    name: 'Sandália Schutz Metalizada Dourada',
    category: 'calcados',
    price: 529.90,
    sizes: ['35', '36', '37', '39'],
    colors: ['Dourado Champagne', 'Prata'],
    description: 'Sandália de salto bloco com tiras finas e acabamento metalizado espelhado.',
    images: ['https://images.unsplash.com/photo-1562273138-f46be4ebdf33?auto=format&fit=crop&w=600&q=80']
  },
  {
    id: 'prod_004',
    name: 'Conjunto Fitness Turquesa Alta Compressão',
    category: 'lancamentos',
    price: 389.90,
    originalPrice: 449.90,
    sizes: ['P', 'M', 'G'],
    colors: ['Verde Turquesa', 'Preto Obsidian'],
    description: 'Top com suporte de alto impacto e legging cós alto anatômico que não fica transparente.',
    images: ['https://images.unsplash.com/photo-1538805060514-97d9cc17730c?auto=format&fit=crop&w=600&q=80'],
    badge: 'Nova Coleção',
    isPopular: true
  },
  {
    id: 'prod_005',
    name: 'Bolsa Baguette Couro Croco',
    category: 'acessorios',
    price: 749.00,
    sizes: ['Único'],
    colors: ['Preto Noir', 'Café'],
    description: 'Bolsa de ombro em couro com textura croco e ferragens banhadas a ouro 18k.',
    images: ['https://images.unsplash.com/photo-1584917865442-de89df76afd3?auto=format&fit=crop&w=600&q=80']
  },
  {
    id: 'prod_006',
    name: 'Mule Carrano Pedrarias',
    category: 'calcados',
    price: 479.90,
    sizes: ['35', '36', '37', '38'],
    colors: ['Preto Veludo', 'Nude'],
    description: 'Mule flat com aplicação de cristais austríacos feitos à mão.',
    images: ['https://images.unsplash.com/photo-1549298916-b41d501d3772?auto=format&fit=crop&w=600&q=80']
  }
];

export const fashionOrders: FashionOrder[] = [
  {
    id: 'PED-#8940',
    customerName: 'Beatriz Montebello',
    items: ['1x Scarpin Luiza Barcelos (Tam 36)', '1x Bolsa Baguette Couro'],
    total: 1398.90,
    status: 'Enviado',
    trackingCode: 'BR984019283SP',
    date: '21/10/2026'
  },
  {
    id: 'PED-#8941',
    customerName: 'Fernanda Lima',
    items: ['1x Conjunto Fitness Turquesa (Tam M)'],
    total: 389.90,
    status: 'Aguardando Envio',
    trackingCode: 'BR984019284SP',
    date: '22/10/2026'
  }
];
